// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__i9wzu","spin":"Loader_spin__Ir7A-"};